export const COMPANY_NAME = "LAS GAVIOTAS OWNERS ASSOCIATION";
export const COMPANY_SHORT = "Las Gaviotas";
export const COMPANY_INITIALS = "LG";
export const COMPANY_ADDRESS_FULL = "313 Susannah Ln, Paso Robles, CA 93446";
export const COMPANY_LOCATION = "Paso Robles, CA";
export const COMPANY_REGION = "San Luis Obispo County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=313%20Susannah%20Ln%2C%20Paso%20Robles%2C%20CA%2093446";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Type", "value": "Common Interest Development" },
  { "label": "Residences", "value": "24 Separate Interests" },
  { "label": "Community", "value": "San Simeon, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Las Gaviotas Owners Association" },
  { "label": "Community", "value": "San Simeon, CA" },
  { "label": "Onsite Office", "value": "Paso Robles, CA" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Common Area Stewardship", "body": "Maintains and oversees the shared grounds and common facilities of the condominium development." },
  { "icon": "✦", "title": "Davis-Stirling Governance", "body": "Operates under the Davis-Stirling Common Interest Development Act with member-guided governance." },
  { "icon": "✿", "title": "Coastal Community Living", "body": "Supports a well-kept, neighborly coastal community of 24 homes near San Simeon." },
  { "icon": "❍", "title": "Member Coordination", "body": "Coordinates association matters and shared services on behalf of owners." },
];
